// extracted by mini-css-extract-plugin
module.exports = {"profileButtonWrapper":"ProfileButtonWrapper_profileButtonWrapper__2mR-W","active":"ProfileButtonWrapper_active__2aBhP"};